
// A sprite instance given a template
function Sprite(template, container, viewport)
{
  this.template = template;
  this.container = container;
  this.viewport = viewport;
  this.element = template.source.clone();
  this.scale = Random( template.scaling );
  this.element.data('scale', this.scale );
  this.element.removeAttr('anim8');
  this.animator = anim8( this.element[0] )[0];
  this.radius = Math.min( this.width(), this.height() ) * template.radius;
  this.children = [];
  this.inactive = false;
  this.angle = 0;
}

Sprite.prototype = 
{
  setPosition: function(x, y) 
  {
    var offsetX = 0;
    var offsetY = 0;

    if ( this.template.placement )
    {
      offsetX = Random( this.template.placement.offsetX, 0 );
      offsetY = Random( this.template.placement.offsetY, 0 );

      if ( this.template.placement.angles )
      {
        this.animator.set({
          rotate: this.angle = Random( this.template.placement.angles )
        });
      }
    }

    this.x = x + offsetX;
    this.y = y + offsetY;
    this.left = this.x - (this.width() * this.template.origin.x);
    this.top = this.y - (this.height() * this.template.origin.y);
    this.cx = this.left + this.width() * 0.5;
    this.cy = this.top + this.height() * 0.5;

    this.element.data( 'left', this.left );
    this.element.data( 'top',  this.top );
  },
  intersects: function(other) 
  {
    var dx = this.cx - other.cx;
    var dy = this.cy - other.cy;
    var distanceSquared = dx * dx + dy * dy;
    var radiusSummed = this.radius + other.radius;
    var radiusSquared = radiusSummed * radiusSummed;

    return distanceSquared < radiusSquared;
  },
  add: function()
  {
    this.element.scale( this.container.getScale() );
    this.element.appendTo( this.viewport );
  },
  width: function() 
  {
    return this.template.width * this.scale;
  },
  height: function()
  {
    return this.template.height * this.scale;
  },
  placeChildOn: function(child, tries, height)
  {
    var range = {min: this.top + child.radius, max: height - child.radius * 2};
    var children = this.children;

    for (var i = 0; i < tries; i++)
    {
      child.setPosition( this.x, Random( range ) );

      var placed = true;

      for ( var k = 0; k < children.length; k++ )
      {
        if ( child.intersects( children[k] ) )
        {
          placed = false;
        }
      }

      if ( placed )
      {
        children.push( child );

        return true;
      }
    }
    return false;
  },
  setCenter: function(x, y)
  {
    this.cx = x;
    this.cy = y;
    this.left = x - this.width() * 0.5;
    this.top = y - this.height() * 0.5;
    this.x = this.left + (this.width() * this.template.origin.x);
    this.y = this.top + (this.height() * this.template.origin.y);
  }
};